import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import usePermission from "../../customHook/usePermission";

const About = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const permission = usePermission();

  const handleView = (row) => {
    if (!row) return;
    navigate("/about-edit", { state: { data: row, mode: "view" } });
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "Language",
        accessor: "language",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "",
        accessor: "s",
        width: "70%",
        Cell: () => {
          return <p className="mb-0"></p>;
        },
      },
      {
        Header: "",
        accessor: "va",
        width: "70%",
        Cell: () => {
          return <p className="mb-0"></p>;
        },
      },
      {
        Header: "",
        accessor: "v",
        width: "70%",
        Cell: () => {
          return <p className="mb-0"></p>;
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-ABOUT_US") && (
              <button
                className="action-btn"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const fetch = async () => {
    try {
      let res = await get(URLS.ABOUT_LIST);
      console.log(res);
      if (res?.status === "success") {
        setData(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching about list:", error);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  console.log("datadata", data);

  return (
    <>
      <PageHeader title="About Us" />
      <CommonTable columns={columns} data={data || []} showPagination={false} />
    </>
  );
};

export default About;
